import React from "react";

import AuthNav from "./auth-nav";

import logoIsoColorBlack from "../common/img/logo-iso-color-black.svg";

const NavBar = () => {
  return (
    <div className="nav-container mb-3">
      <nav className="navbar navbar-expand-md navbar-light bg-light">
        <div className="container">
          <img
            className="mb-3 app-logo"
            src={logoIsoColorBlack}
            alt="React logo"
            width="100"
          />
          <p className="lead typewriter">Kinzbio Software Toolset</p>
          {/*<MainNav />*/}
          <AuthNav />
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
